import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Card = styled.div<{ $highlighted?: boolean }>`
  border-radius: 12px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  margin-bottom: 32px;
  border: ${({ $highlighted, theme }) =>
    $highlighted
      ? `2px solid ${theme.colors['primary-30']}`
      : `2px solid ${theme.colors['neutral-20']}`};

  ${media.mobile} {
    padding: 16px;
    margin-bottom: 20px;
    border-radius: 8px;
  }
`;

export const Header = styled.div<{ $hasSubtitle?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: ${({ $hasSubtitle }) => ($hasSubtitle ? '4px' : '16px')};
`;

export const Title = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors['neutral-70']};
`;

export const ActionWrapper = styled.div`
  margin-left: auto;
`;

export const Subtitle = styled.span`
  display: block;
  font-size: 13px;
  color: ${({ theme }) => theme.colors['neutral-60']};
  margin-bottom: 16px;
`;
